import { createActions } from 'redux-actions';

export const { setDashboardSessions, clearDashboardSessions } = createActions(
  'SET_DASHBOARD_SESSIONS',
  'CLEAR_DASHBOARD_SESSIONS',
);
